export const GET_CONTENT_USAGE_QUERY = /* GraphQL */ `
  query ($contentId: ID!) {
    result: getContentUsage(id: $contentId) {
      siteId
      siteTitle
      baseUrl
      deployedAt
      usages {
        path
        depth
      }
    }
  }
`;

export const GET_PREVIEW_ROUTES = /* GraphQL */ `
  {
    result: getPreviewPathList {
      contentTypeId
      contentTypeName
      sites {
        siteId
        siteTitle
        token
        routes {
          routeName
          path
          isPaginated
        }
      }
    }
  }
`;
